import api from "./Api";

export default class DestinatarioAssociadoService {
  getRecipientByDocument(document) {
    return api
      .get(`/api/v1/associated-recipient?document=${encodeURIComponent(document)}`, {})
      .then((response) => response.data)
      .catch((err) => {
        console.log("Erro ao buscar destinatário associado:", err);
        throw err;
      });
  }
}
